import { Route } from '@angular/router';

export const SiteRoutes: Route[] = [
  {
    path: 'site',
    children: [
      {
        path: 'banner',
        loadComponent: () => import('../pages/site/banner/banner.page'),
      },
      {
        path: 'business-info',
        loadComponent: () =>
          import('../pages/site/business-info/business-info.page'),
      },
      {
        path: 'settlement-config',
        loadComponent: () =>
          import('../pages/site/settlement-config/settlement-config.page'),
      },
      {
        path: 'terms',
        loadComponent: () => import('../pages/site/terms/terms.page'),
      },
      {
        path: 'popup',
        loadComponent: () => import('../pages/site/popup/popup.page'),
      },
    ],
  },
];
